import { apiClient } from "./client";
import type { AuditLogFilters, AuditLogQueryResultDto } from "./types";

/**
 * §10.1 审计日志自由查询:按操作对象/动作/操作人(子串匹配)、结果(精确匹配)
 * 组合筛选,支持分页,查询范围覆盖全部历史记录(不限定当月)。
 */
export function queryAuditLog(filters: AuditLogFilters = {}) {
  return apiClient.get<AuditLogQueryResultDto>("/audit-log", {
    subject_key: filters.subjectKey,
    action: filters.action,
    actor: filters.actor,
    result: filters.result,
    page: filters.page,
    page_size: filters.pageSize,
  });
}
